var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00008 12.6667C9.73342 12.6667 10.3334 12.0667 10.3334 11.3333C10.3334 10.6 9.73342 10 9.00008 10C8.26675 10 7.66675 10.6 7.66675 11.3333C7.66675 12.0667 8.26675 12.6667 9.00008 12.6667ZM13.0001 6.66667H12.3334V5.33333C12.3334 3.49333 10.8401 2 9.00008 2C7.16008 2 5.66675 3.49333 5.66675 5.33333V6.66667H5.00008C4.26675 6.66667 3.66675 7.26667 3.66675 8V14.6667C3.66675 15.4 4.26675 16 5.00008 16H13.0001C13.7334 16 14.3334 15.4 14.3334 14.6667V8C14.3334 7.26667 13.7334 6.66667 13.0001 6.66667ZM6.93341 5.33333C6.93341 4.19333 7.86008 3.26667 9.00008 3.26667C10.1401 3.26667 11.0667 4.19333 11.0667 5.33333V6.66667H6.93341V5.33333ZM13.0001 14.6667H5.00008V8H13.0001V14.6667Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.0051b171.svg";
export { ForwardRef as ReactComponent };